export const defaultFilters = {
  orientation: [],
  created_at: null,
  availability: null,
  comments: null,
  tags: [],
  custom_fields: {},
  filetypes: [],
};

const mapUploadedDate = (searchValue) => {
  if (searchValue.indexOf('TO') > -1) { // created_at date range
    const seperators = ['\\[', '\\]', 'TO']; // separate on '[', ']' and 'TO'
    const regexSeperators = new RegExp(seperators.join('|'), 'g');
    const dateRange = searchValue.split(regexSeperators);

    return `uploaded: between ${dateRange[1]}and${dateRange[2]}`;
  }

  const createdAtMap = {
    'created_at: >now-1d': 'uploaded: last 24 hours',
    'created_at: >now-7d': 'uploaded: last 7 days'
  };

  return createdAtMap[searchValue];
};

const checkAndUpdateFilterStringArray = (value, filterStrings) => {
  // handle 'created_at' filter string updates
  if (value.includes('created_at')) {
    for (let i = 0; i < filterStrings.length; i += 1) {
      if (filterStrings[i].indexOf('uploaded') > -1) {
        filterStrings.splice(i, 1); // remove existing created_at filters
      }
    }

    if (!value.includes('null')) {
      filterStrings.push(mapUploadedDate(value));
    }
  }

  // handle filter string updates if not 'created_at'
  if (!value.includes('created_at')) {
    const valueIndex = filterStrings.indexOf(value);

    if (valueIndex > -1) {
      filterStrings.splice(valueIndex, 1);
    } else {
      filterStrings.push(value);
    }
  }

  return filterStrings;
};

const updateFilters = ({
  filters,
  filterStrings: filterStrings_,
  filterType,
  keyValue,
  subValue,
}) => {
  let scrubbedKeyValue, scrubbedSubValue;
  let filterStrings = filterStrings_;
  const currentFilters = Object.assign({}, filters);
  switch (filterType) {
    case "tags":
      scrubbedKeyValue = keyValue.replace('"', '\\"')
      scrubbedSubValue = subValue;
      break;
    case "custom_fields": case "remove_custom_field":
      scrubbedKeyValue = keyValue;
      scrubbedSubValue = subValue.replace('"', '\\"');
      break;
    default:
      scrubbedKeyValue = keyValue;
      scrubbedSubValue = subValue;
      break;
  }
  switch (filterType) {
    case "orientation": case "tags": case "filetypes":
      filterStrings = checkAndUpdateFilterStringArray(keyValue, filterStrings);
      if (keyValue === null) {
        currentFilters.filterType = [];
      } else {
        const existingValue = currentFilters[filterType].indexOf(scrubbedKeyValue);
        if (existingValue > -1) {
          currentFilters[filterType].splice(existingValue, 1);
        } else {
          currentFilters[filterType].push(scrubbedKeyValue);
        }
      }
      break;
    case "custom_fields":
      filterStrings = checkAndUpdateFilterStringArray(`${keyValue}: ${subValue}`, filterStrings);
      if (subValue) {
        currentFilters[filterType] = currentFilters[filterType] || {};
        currentFilters[filterType][keyValue] = currentFilters[filterType][keyValue] || [];
        currentFilters[filterType][keyValue].push(scrubbedSubValue);
      }
      break;
    case "remove_custom_field":
      filterStrings = checkAndUpdateFilterStringArray(`${keyValue}: ${subValue}`, filterStrings);
      currentFilters.custom_fields[keyValue] = currentFilters.custom_fields[keyValue].filter((value) => value !== scrubbedSubValue);
      if (currentFilters.custom_fields[keyValue].length === 0) {
        delete currentFilters.custom_fields[keyValue];
      }
      break;
    case "comments":
      filterStrings = checkAndUpdateFilterStringArray("comments", filterStrings);
      if (currentFilters[filterType] === true) {
        currentFilters[filterType] = null;
        break;
      } else {
        currentFilters[filterType] = keyValue;
        break;
      }
    case "strict":
      filterStrings = checkAndUpdateFilterStringArray("strict", filterStrings);
      if (currentFilters[filterType] === true) {
        currentFilters[filterType] = false;
        break;
      } else {
        currentFilters[filterType] = keyValue;
        break;
      }
    case 'created_at':
      filterStrings = checkAndUpdateFilterStringArray(`${filterType}: ${keyValue}`, filterStrings);
      currentFilters[filterType] = keyValue;
      break;
    default:
      currentFilters[filterType] = keyValue;

      if (keyValue !== null) {
        filterStrings = checkAndUpdateFilterStringArray(keyValue, filterStrings);
      }

      break;
  }
  let sections = "";
  if (JSON.stringify(currentFilters) === JSON.stringify(defaultFilters)) {
    sections = "all";
  }

  return {
    filters: currentFilters,
    activeSection: sections,
    filterStrings,
  };
};

export default updateFilters;
